import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':equipmentCostId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:equipmentCostId`;

export const URL = (equipmentCostId: number): RouteDefinition => `${baseRoute}/${equipmentCostId}`;
